import { baseService } from '@services/base.service';
import { UserPlanning } from '@common-types';
import { PlannerQuestionerData } from '@store/PlannerQuestionerStore';

export async function postPlannerQuestionerData(data: PlannerQuestionerData) {
  return baseService.postAsync<UserPlanning, unknown>(`/user/planning`, data);
}

export async function patchPlannerQuestionerData(data: PlannerQuestionerData) {
  return baseService.patchAsync<UserPlanning, unknown>(`/user/planning`, data);
}
